import React from 'react'
import PopUp from '../../api/components-examples/PopUP'
import WaitingLoaders from '../Loaders/WaitingLoaders.jsx'
import { NormalButton } from '../../api/components-examples/ReusableCode/EmlyButton'
import CpInvite from '../../api/components-examples/Welcome/CpInvite'
import { ProjectCreationForm } from '../../api/components-examples/Welcome/ProjectCreationForm.js'
import { setProjectInfoKey } from '../../api/redux/FrameWorkReducer'
import { addNotification, showNotification } from '../../api/redux/notificationAction'
import { getPaymentProductId } from './projectHelpers'

const ProjectCreation = ({
    createRecord,
    SelectedFlow,
    dispatch,
    flowId,
    flowDescrption,
    setProjectPopup,
    currenItem,
    navigateTo,
    myProfile,
    isBuild,
    isSubscriptionCheck,
    buyCourse,
    isLoadingUPlan,
    RgroupId,
    upCreate,
    fetchAllgroups,
    uPCreation,
    projectCreated,
    formDialogue,
    groupLoading,
    createProject,
    inviteUsertoProject,
    addProjectToGroup,
    flowGroups,
    wGroupCreated,
    getIsLocked,
    isAddedDone,
    refreshGroups,
    projectCreationError,
    updateProjectCreationError,
    checkToProject,
    getAvailableUserRoles
}) => {
    const handleTextInputChange = e => {
        setTextInput(e.target.value)
        updateProjectCreationError()
    }

    const handleDescriptionChange = e => {
        setDescription(e.target.value)
        updateProjectCreationError()
    }

    const [textInput, setTextInput] = React.useState(SelectedFlow)
    const [description, setDescription] = React.useState(flowDescrption)
    const [groupId, setGroupId] = React.useState('')
    const [showAdvanced, setShowAdvanced] = React.useState(false)

    const availedPlan =
        isSubscriptionCheck &&
            !isSubscriptionCheck.isLoading &&
            isSubscriptionCheck.subscribedProduct &&
            isSubscriptionCheck.subscribedProduct.name
            ? isSubscriptionCheck.subscribedProduct.name
            : 'NO_PLAN'

    const getUpgradedPlans = () => {
        if (currenItem['plan'] && currenItem['plan'].length > 0 && availedPlan) {
            const arr = currenItem['plan'].filter(item => item !== availedPlan)
            if (arr.length > 0) {
                let result = []
                for (let i = 0; i < arr.length - 1; i++) {
                    result.push(arr[i])
                    result.push(' Or ')
                }
                result.push(arr[arr.length - 1])
                return result
            }
        }
    }

    const upgradePlans = getUpgradedPlans()

    const IsEmpty = () => {
        dispatch(addNotification('Please fill in all required fields', 'danger', false))
        dispatch(showNotification(true))
    }

    const getAllGroups = () => {
        const groups =
            fetchAllgroups &&
            fetchAllgroups.groupList &&
            fetchAllgroups.groupList.reduce((acc, next) => {
                if (next['tags'].includes('USERS')) {
                    return [...acc, { label: next.title, value: next.id, groupInfo: next }]
                } else {
                    return acc
                }
            }, [])
        return groups
    }

    const groupInfoNotAvailable = () => {
        dispatch(addNotification('Please select a group.', 'danger', false))
        dispatch(showNotification(true))
    }

    const groupUsers0 = () => {
        dispatch(
            addNotification('Please select a different group, as there are no users in the current group.', 'danger', false)
        )
        dispatch(showNotification(true))
    }

    const createNewRecord = () => {
        if (showAdvanced === true && (groupId === '' || groupId === undefined)) {
            groupInfoNotAvailable()
        } else {
            if (
                groupId !== '' &&
                groupId !== undefined &&
                groupId['groupInfo'] &&
                groupId['groupInfo']['numberOfUsers'] === 0
            ) {
                groupUsers0()
                return
            } else
                createRecord({
                    title: textInput,
                    space_desc: description,
                    flowId: flowId,
                    roleName: (getAvailableUserRoles && getAvailableUserRoles.roles && getAvailableUserRoles.roles.find(r => r.name && r.name.toLowerCase() === 'learner')) ? 'learner' : 'member',
                    groupId: groupId['value'],
                    groupName: groupId['label'],
                    showAdvanced: showAdvanced
                })
        }
    }

    const getGroupTitle = () => {
        const map = new Map(Object.entries(flowGroups))
        const currentGroup = map.get(RgroupId)
        if (!currentGroup) {
            const groupId = { title: RgroupId ? RgroupId.replaceAll('_', ' ') : currenItem['label'] }
            return groupId
        }
        return currentGroup
    }

    const checkOutToProjectPage = wGroupCreated => {
        console.log(wGroupCreated)
        const link = { pathname: '/projects', state: 'GOTOGROUP', value: { groupKey: RgroupId, groupId: wGroupCreated.id } }
        navigateTo(link)
        dispatch(setProjectInfoKey(new Date().getTime()))
    }

    const isLocked = getIsLocked(currenItem)

    const buyNowpurchase = isLocked === true && (!isBuild || isBuild) ? 'buyNow_purchase' : ''

    return (
        <PopUp className={buyNowpurchase} width={buyNowpurchase ? '590px' : '70%'} bottomButton={false} bottomButtonCancel={false} onCancel={() => setProjectPopup()} loadingCancel={true}>
            {formDialogue && !uPCreation && (
                <WaitingLoaders show={true} size={90} message={`Your project is getting created, Please wait`} position='absolute' />
            )}
            {isLocked == true && isBuild ? (
                <>
                    <div className="em-row">
                        {isLoadingUPlan && <WaitingLoaders show={true} size={90} position='absolute' />}
                        <div className="em-buyCourse-parent">
                            <div className="em-buycourse-img">
                                <img src={require('../../images/buyNowpurchase.png')} />
                            </div>
                            <div className="em-buycourse-description">
                                {myProfile.roles === 'owner' ? (
                                    <span className="des_1">
                                        <b>{getGroupTitle().title}</b> isn't available in your <b>{availedPlan} plan.</b> To access it, please upgrade {' '}
                                        {upgradePlans.length === 1 ? 'to' : ' either to '} <b>{upgradePlans && upgradePlans.join(' ')}</b> Plan{' '}
                                    </span>
                                ) : (
                                    <span className="des_1">
                                        <b>{getGroupTitle().title}</b> isn't available in your <b>{availedPlan} plan.</b> To access it, please contact your admin for further
                                        assistance.
                                    </span>
                                )}

                                <span className="des_3">
                                    {myProfile.roles === 'owner' ? (
                                        <>
                                            <button className={'em-btn later'} onClick={() => setProjectPopup()}>
                                                Later
                                            </button>
                                            <button className={'em-btn -p-t-buy'} onClick={() => { navigateTo('/organizations/billings') }}>
                                                Upgrade Plan
                                            </button>
                                        </>
                                    )
                                        :
                                        <>
                                            <button className={'em-btn later'} onClick={() => setProjectPopup()}>
                                                Close
                                            </button>
                                        </>
                                    }
                                </span>
                                <span className="des_4">
                                    Note: If you have already upgraded, please refresh this page.
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : isLocked == true && !isBuild ? (
                <>
                    <div className="em-row">
                        {isLoadingUPlan && <WaitingLoaders show={true} size={90} position='absolute' />}
                        <div className="em-buyCourse-parent">
                            <div className="em-buycourse-img">
                                <img src={require('../../images/buyNowpurchase.png')} />
                            </div>
                            <div className="em-buycourse-description">
                                {myProfile.roles === 'owner' ? (
                                    <span className="des_1">
                                        <b>{currenItem['label']}?</b> module isn't accessible,  you can access it by purchasing following course {' '}
                                    </span>
                                ) : (
                                    <span className="des_1">
                                        <b>{currenItem['label']}?</b> module isn't accessible, to access it, please contact your admin for further assistance.
                                    </span>
                                )}
                                <span className="des_2">
                                    <b>{getGroupTitle().title}</b><br />
                                    <ul>
                                        <li>Modules: {getGroupTitle().modules}</li>
                                        <li>Hours : {getGroupTitle().hours}</li>
                                    </ul>
                                    <a href={currenItem.course_link ? currenItem.course_link : 'https://emlylabs.com/'} target="_blank">
                                        {' '}
                                        View Course Details&nbsp;&nbsp;<i class="fa fa-external-link" aria-hidden="true"></i>
                                    </a>{' '}
                                </span>

                                <span className="des_3">
                                    {myProfile.roles === 'owner' ? (
                                        <>
                                            <button className={'em-btn later'} onClick={() => setProjectPopup()}>
                                                Later
                                            </button>
                                            <button className={'em-btn -p-t-buy'} onClick={() => buyCourse(getPaymentProductId(currenItem, flowGroups))}>
                                                Proceed to Buy
                                            </button>
                                        </>
                                    )
                                        :
                                        <>
                                            <button className={'em-btn later'} onClick={() => setProjectPopup()}>
                                                Close
                                            </button>
                                        </>
                                    }
                                </span>
                                <span className="des_4">
                                    Note: If you have already purchased this course please refresh this page.
                                </span>
                            </div>
                        </div>
                    </div>
                </>
            ) : uPCreation === true && upCreate === true ? (
                <>
                    <CpInvite
                        projectTitle={textInput}
                        memberList={projectCreated}
                        retryCreateProject={createProject}
                        retryInviteUser={inviteUsertoProject}
                        retryAddProjectToGroup={addProjectToGroup}
                    />
                    {isAddedDone &&
                        <div className="em-row em-flex" style={{ justifyContent: 'flex-end', gap: '15px' }}>
                            <NormalButton onClick={() => setProjectPopup()} style={{ marginTop: '15px' }} className="em-btn em-danger">
                                Close
                            </NormalButton>
                            {formDialogue === false && (
                                <NormalButton
                                    onClick={() => checkOutToProjectPage(wGroupCreated)}
                                    style={{ marginTop: '15px' }}
                                    className="em-btn"
                                >
                                    Navigate to Group
                                </NormalButton>
                            )}
                        </div>}
                </>
            ) : (
                <>
                    {groupLoading && (
                        <WaitingLoaders show={true} size={90} position='absolute' />
                    )}
                    <ProjectCreationForm
                        groupLoading={groupLoading}
                        textInput={textInput}
                        handleTextInputChange={handleTextInputChange}
                        description={description}
                        handleDescriptionChange={handleDescriptionChange}
                        flowId={flowId}
                        isBuild={isBuild}
                        setGroupId={setGroupId}
                        setShowAdvanced={setShowAdvanced}
                        showAdvanced={showAdvanced}
                        getAllGroups={getAllGroups}
                        setProjectPopup={setProjectPopup}
                        createNewRecord={createNewRecord}
                        IsEmpty={IsEmpty}
                        refreshGroups={refreshGroups}
                        projectCreationError={projectCreationError}
                        updateProjectCreationError={updateProjectCreationError}
                        checkToProject={checkToProject}
                    />
                </>
            )}
        </PopUp>
    )
}

export default ProjectCreation
